import eq from "lodash-es/eq"

import { buildCssClassName } from "@/3514/utils"

import { ECoachInfoIntegrationMode as EMode } from "./coach-info.types"

const styles = {
    section: ({ mode }: { mode: EMode }): string =>
        buildCssClassName(
            "[display:grid]",
            "grid-cols-[1fr]",
            "lg:grid-cols-[minmax(min-content,25%)_1fr]",
            "lg:items-start",
            "max-lg:gap-[20px]",
            "w-full",
            "rounded-[10px]",
            "bg-blue-500",
            "py-[40px]",
            "lg:pt-[30px]",
            "lg:pb-[40px]",
            {
                "my-[20px]": eq(mode, EMode.CoachingSessions)
            }
        ),
    leftCol: ({ mode }: { mode: EMode }): string =>
        buildCssClassName("px-[50px] flex flex-col items-center justify-start", {
            "lg:mt-[40px] gap-y-[25px]": eq(mode, EMode.CoachingSessions),
            "gap-y-[20px]": eq(mode, EMode.OnboardingCoach)
        }),
    leftColTextWrapper: (): string => "[display:grid] gap-[5px] items-center",
    leftColName: (): string => "max-w-fit md:max-w-[155px] truncate mx-auto",
    rightCol: (): string =>
        buildCssClassName(
            "px-[45px]",
            "flex",
            "flex-col",
            "items-center",
            "lg:items-start",
            "justify-center",
            "gap-y-[15px]",
            "lg:gap-y-[25px]",
            "lg:border-l-[1px]",
            "lg:border-blue-400"
        ),
    rightColBioWrapper: (): string => "overflow-hidden relative flex flex-col",
    rightColBioContainerShadow: ({ isContainerExpanded }: { isContainerExpanded: boolean }): string =>
        buildCssClassName(
            isContainerExpanded ? "opacity-0" : "opacity-1 absolute w-full z-[1] bottom-[-5px] h-[25px] bg-blue-500/60"
        ),
    rightColBio: (): string => "text-pretty text-center lg:text-left hyphens-auto",
    rightColBioToggler: (): string =>
        buildCssClassName(
            "flex",
            "justify-center",
            "items-center",
            "cursor-pointer",
            "gap-x-[5px]",
            "max-lg:mx-auto",
            "relative",
            "w-fit",
            "after:absolute",
            "after:bottom-[-3px]",
            "after:h-[1px]",
            "after:w-full",
            "after:bg-transparent",
            "hover:after:bg-accent",
            "focus-visible:after:bg-accent"
        ),
    rightColBioTogglerText: (): string => "capitalize"
} as const

export { styles as coachInfoStyles }
